import { createStore } from "vuex";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

const store = new createStore({
  state: {
    userPool: [],
    cognitoUser: "",
    username: "",
    authenticated: false,
    selectedHospital: -1,
    selectedPackageList: [],
  },
  mutations: {
    getAuthenticatedUser(state) {
      state.userPool.getCurrentUser();
    },
    signOut(state) {
      this.getAuthenticatedUser().signOut();
      state.authenticated = false;
      state.username = "";
      state.cognitoUser = "";
      state.userPool = [];
      console.log("store: signed out");
    },
    isAuthenticated(state) {
      const user = this.getAuthenticatedUser();
      user.getSession((err, session) => {
        if (err) {
          console.log(err);
          state.authenticated = false;
        } else {
          if (session.isValid()) {
            console.log(session);
            state.authenticated = true;
          }
        }
      });
    },
    setSelectedHospital(state, selectedHospital) {
      state.selectedHospital = selectedHospital;
    },
    setSelectedPackageList(state, packageList) {
      state.selectedPackageList = packageList;
    },
  },
  plugins: [vuexLocal.plugin],
});

export default store;
